<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display:flex;justify-content:flex-start;align-items:center;">
        <button-add @click="toAddPage" v-if="permissionCodes.indexOf('043002001') !== -1"></button-add>
        <!-- <button-delete @deleteSelection="deleteSelection" v-if="permissionCodes.indexOf('036001003') !== -1"/> -->
        <!-- <button-upload :cathUrl="uploadUrl" @getpage="getPage" :onSuccess="onUploadSuccess" value="导入" v-if="permissionCodes.indexOf('036001004') !== -1"/> -->
      </div>
      <!-- <input-select selectTitle="物资类目筛选" :selectKey="'fix'" :selectData="fixTypeList"  @search="search"/> -->
      <!-- <input-search  placeholder="物资类目"  @search="searchKey" /> -->
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :operationArr="operationArr" @deleteLine="deleteLine" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination" :total="total" @goToModifyPage="goToModifyPage"/>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/CustomerFlow";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nAlert, nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "police-point-management",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "视频报警",
          name: "video-alarm-over-view"
        },
        {
          value: "报警点管理"
        }
      ],
      fixTypeList: [],
      tableHead: [
        {
          prop: "name",
          label: "报警点名称"
        },
        {
          prop: "deviceName",
          label: "关联设备名称"
        },
        {
          prop: "memo",
          label: "备注"
        }
      ],
      tableData: [],
      operationArr: ["modify", "delete"],
      requestData: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1
      },
      uploadUrl: "",
      total: 0,
      selectionArr: []
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    getPage() {
      this.$axios
        .post(api.getMonitorPointPage, this.requestData)
        .then(res => {
          this.total = res.data.data.total;
          let list = res.data.data.list;
          this.tableData = list;
        })
        .catch(errorHandler("获取物资类目列表失败"));
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteMonitorPoint, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    },
    toAddPage() {
      this.$router.push({
        name: "police-point-management-add"
      });
    },
    goToModifyPage(code) {
      this.$router.push({
        path: `police_point_management_modify/${code}`
      });
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    deleteSelection() {
      if (this.selectionArr.length === 0) {
        nAlert("请先选择需要删除的物资类目");
        return false;
      } else {
        this.$confirm("是否确认删除物资类目？", "提示")
          .then(() => {
            this.deleteLine(this.selectionArr);
          })
          .catch(() => {
            console.log("取消删除");
          });
      }
    },
    onUploadSuccess(data) {
      if (data.retCode == 1) {
        nSuccess("导入成功");
        this.pageSize = 10;
        this.pageNum = 1;
        this.getPage();
      } else {
        errorHandler("导入失败")(data);
      }
    }
  }
};
</script>


<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/VideoAlarm/PolicePointManagement/PolicePointManagement.vue